import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SlideTogglePadraoComponent} from '../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component';
import {FluxoSalvarModel} from '../../shared/model/fluxo/fluxo-salvar-model';
import {FormFieldComponent} from '../../shared/components/form-field/form-field.component';
import {ButtonPadraoComponent} from '../../shared/components/button-padrao/button-padrao.component';
import {MsgService} from '../../shared/service/msg.service';
import {ValidacaoAlteracaoCampoService} from '../../shared/service/utilitarios/validacao-alteracao-campo.service';
import {TipoFluxoEnum} from '../../shared/enum/tipo-fluxo.enum';

@Component({
  selector: 'app-modal-cadastro-visualizacao-fluxo',
  standalone: true,
  imports: [
    SlideTogglePadraoComponent,
    FormFieldComponent,
    ButtonPadraoComponent
  ],
  templateUrl: './modal-cadastro-visualizacao-fluxo.component.html',
  styleUrl: './modal-cadastro-visualizacao-fluxo.component.css'
})
export class ModalCadastroVisualizacaoFluxoComponent implements OnInit {
  visualizar = false;
  fluxo: FluxoSalvarModel = new FluxoSalvarModel();
  isErro = false;

  private readonly msgService = inject(MsgService);
  private readonly dialogRef = inject(MatDialogRef<ModalCadastroVisualizacaoFluxoComponent>);
  public readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);
  public data: any = inject(MAT_DIALOG_DATA);

  ngOnInit() {
    this.visualizar = this.data['visualizar'];
    this.fluxo = this.data['fluxo'];
    const tipo: any = this.fluxo.tipo;
    this.isErro = !!(tipo && tipo === 'ERRO');
    this.alteracaoService.camposNaoAlterados();
  }

  validado(): boolean {
    return !!(this.fluxo
      && this.fluxo.titulo && this.fluxo.titulo.length > 0
      && this.fluxo.descricao && this.fluxo.descricao.length > 0);
  }

  salvar() {
    if (this.validado()) {
      this.fluxo.tipo = this.isErro ? TipoFluxoEnum.ERRO : TipoFluxoEnum.PADRAO;
      this.dialogRef.close(this.fluxo);
    } else {
      this.msgService.msgAdvertencia('Preencha o campo de título');
    }
  }

  cancelar() {
    this.dialogRef.close();
  }
}
